export default __webpack_public_path__ + "static/media/bag.e77bfba9.png";